var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var EventProxy = /** @class */ (function () {
    function EventProxy() {
        var _this = this;
        this.proxies = {};
        this.onceProxies = {};
        this.on = function (eventName, handler) {
            if (_this.proxies[eventName]) {
                return _this.proxies[eventName].push(handler);
            }
            _this.proxies[eventName] = [handler];
        };
        this.only = function (eventName, handler) {
            _this.proxies[eventName] = [handler];
        };
        this.once = function (eventName, handler) {
            if (_this.onceProxies[eventName]) {
                return _this.onceProxies[eventName].push(handler);
            }
            _this.onceProxies[eventName] = [handler];
        };
        this.emit = function (eventName) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (_this.proxies[eventName]) {
                _this.proxies[eventName].forEach(function (handler) { return handler.apply(void 0, __spreadArray([], __read(args))); });
            }
            if (_this.onceProxies[eventName]) {
                _this.onceProxies[eventName].forEach(function (handler) { return handler.apply(void 0, __spreadArray([], __read(args))); });
                _this.onceProxies[eventName] = [];
            }
        };
        this.cancel = function (eventName, handler) {
            if (!_this.proxies[eventName])
                return;
            _this.proxies[eventName] = _this.proxies[eventName].filter(function (h) { return h !== handler; });
        };
        this.cancelOnce = function (eventName, handler) {
            if (!_this.onceProxies[eventName])
                return;
            _this.onceProxies[eventName] = _this.onceProxies[eventName].filter(function (h) { return h !== handler; });
        };
        this.cancelAll = function (eventName) {
            if (!_this.proxies[eventName])
                return;
            _this.proxies[eventName] = [];
        };
        this.cancelAllOnce = function (eventName) {
            if (!_this.onceProxies[eventName])
                return;
            _this.onceProxies[eventName] = [];
        };
        this.clear = function () {
            _this.proxies = {};
            _this.onceProxies = {};
        };
    }
    return EventProxy;
}());
export { EventProxy };
//# sourceMappingURL=eventProxy.js.map